<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Dog Point Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Uno dei (molti) vantaggi dei vini del nuovo mondo è che non hanno gli stessi ostacoli
                        che avevano i loro antenati. Tutto, dai raccolti verdi all'invecchiamento in botti nuove o vecchie, ha
                        stato provato e testato. Quindi, mentre molti di questi vini sono giovani, se ne sono salvati 100
                        anni quindi studiando le migliori pratiche portate dall'Europa. Uno di questi ex studenti è Dog
                        Point Vineyards a Marlborough, la principale regione vinicola della Nuova Zelanda.
                    </div>

                    <div class="howto-title2">Punto sul punto</div>
                    <div class="howto-text">
                        Quasi sin dal suo inizio, Dog Point è stato tra i migliori produttori di vino in Nuova Zelanda. Producendo quattro fantastici vini, l'attenta maestria dell'enologo James Healy e del viticoltore Ivan Sutherland ha fatto guadagnare all'etichetta un seguito di culto, sia in Nuova Zelanda che all'estero. Il duo Healy/Sutherland, tuttavia, risale ai giorni precedenti alla DP. I due si sono incontrati mentre erano entrambi a Cloudy Bay (Sutherland è stato il viticoltore di Cloudy Bay per 18 anni mentre Healy è stato l'enologo dell'azienda per 12 anni. Sutherland è stato anche direttore del marchio prima di andarsene). L'incontro dei due si è rivelato, letteralmente, fruttuoso e nel 2004 hanno lanciato il proprio marchio, Dog Point. Con 30 anni accumulati alle spalle, questo potente duo non poteva sbagliare e, in soli 15 anni, Dog Point è diventato il punto di riferimento per Sauvignon Blanc, Pinot Noir e Chardonnay nel settore.
                    </div>

                    <div class="howto-title2">Filosofie del vecchio mondo e tecnologia del nuovo mondo</div>
                    <div class="howto-text">
                        I vini di Ivan e James mostrano una qualità e una complessità sorprendenti. Non solo è la loro argilla fessurata
                        terroir il migliore di Marlborough, ma le viti di 40 anni di Dog Point sono tra le più vecchie del
                        regione. Le rese sono mantenute basse - almeno il 50% al di sotto della media - e insolitamente per la Nuova Zelanda, l'uva
                        vengono raccolte a mano. Questo è degno di nota poiché la raccolta manuale è una delle poche europee
                        elementi enologici che non hanno raggiunto gli antipodi; Il 95% dei raccolti avviene a macchina. I loro quattro
                        le miscele firmate sono tutte della stessa qualità e prezzo, tuttavia, se dovessimo sceglierne una, lo farebbe
                        essere il vigneto Dog Point Sezione 94 Sauvignon Blanc. Il 2008 ha goduto di un forte aumento all'inizio del secondo trimestre
                        2019, rendendola la scelta saggia dei neofiti del nuovo mondo.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Dog Point Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Einer der (vielen) Vorteile von Weinen aus der Neuen Welt besteht darin, dass sie nicht die gleichen Stolpersteine haben
                        dass ihre Vorfahren hatten. Alles – von grünen Ernten bis hin zur Reifung in neuen oder alten Fässern – hat
                        erprobt und getestet. Obwohl viele dieser Weine jung sind, haben sie sich 100 Stück gespart
                        Jahre lang, indem wir bewährte Verfahren aus Europa studiert haben. Einer dieser ehemaligen Studenten ist Dog
                        Point Vineyards in Marlborough, Neuseelands wichtigstem Weinanbaugebiet.
                    </div>

                    <div class="howto-title2">Hund Punkt für Punkt</div>
                    <div class="howto-text">
                        Fast seit seiner Gründung gehört Dog Point zu den besten Weinproduzenten Neuseelands. Die sorgfältige Handwerkskunst des Önologen James Healy und des Winzers Ivan Sutherland hat dem Label durch die Herstellung von vier fantastischen Weinen eine Kult-Anhängerschaft eingebracht, sowohl in Neuseeland als auch im Ausland. Das Healy/Sutherland-Duo stammt jedoch aus der Zeit vor DP. Das Paar lernte sich kennen, als sie beide in Cloudy Bay waren (Sutherland war 18 Jahre lang der Winzer von Cloudy Bay, während Healy 12 Jahre lang der Önologe des Unternehmens war. Sutherland war vor seinem Weggang auch Direktor der Marke). Das Treffen der beiden erwies sich im wahrsten Sinne des Wortes als fruchtbar und im Jahr 2004 gründeten sie ihre eigene Marke, Dog Point. Mit insgesamt 30 Jahren hinter sich konnte dieses kraftvolle Duo nichts falsch machen, und in nur 15 kurzen Jahren wurde Dog Point zum Maßstab für Sauvignon Blancs, Pinot Noirs und Chardonnays in der Branche.
                    </div>

                    <div class="howto-title2">Philosophien der alten Welt und Technologie der neuen Welt</div>
                    <div class="howto-text">
                        Die Weine von Ivan und James zeichnen sich durch erstaunliche Qualität und Komplexität aus. Ihr Ton ist nicht nur spaltig
                        Das Terroir ist das beste in Marlborough, aber die 40 Jahre alten Reben von Dog Point gehören zu den ältesten in der Region
                        Region. Die Erträge werden niedrig gehalten – mindestens 50 % unter dem Durchschnitt – und die Trauben sind ungewöhnlich für Neuseeland
                        werden von Hand geerntet. Dies ist erwähnenswert, da die Ernte von Hand eine der wenigen in Europa ist
                        Weinherstellungselemente, die nicht die Antipoden getroffen haben; 95 % der Ernten erfolgen maschinell. Ihre vier
                        Signature-Mischungen haben alle die gleiche Qualität und den gleichen Preis. Wenn wir uns jedoch für eine entscheiden würden, wäre dies der Fall
                        sei der Dog Point Vineyard Section 94 Sauvignon Blanc. Das Jahr 2008 erlebte zu Beginn des zweiten Quartals einen starken Anstieg
                        2019, was es zur klugen Wahl der New-World-Neulinge macht.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Dog Point Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'un des (nombreux) avantages des vins du nouveau monde est qu'ils n'ont pas les mêmes écueils
                        que possédaient leurs ancêtres. Tout - des vendanges vertes à l'élevage en barriques neuves ou anciennes - a
                        été essayé et testé. Ainsi, alors que beaucoup de ces vins sont jeunes, ils ont économisé 100
                        ans en étudiant les meilleures pratiques importées d'Europe. L'un de ces anciens étudiants est Dog
                        Point Vineyards à Marlborough, la principale région viticole de Nouvelle-Zélande.
                    </div>

                    <div class="howto-title2">Chien point sur point</div>
                    <div class="howto-text">
                        Presque depuis sa création, Dog Point figure parmi les meilleurs producteurs de vin de Nouvelle-Zélande. Produisant quatre vins fantastiques, le savoir-faire minutieux de l'œnologue James Healy et du viticulteur Ivan Sutherland a valu à l'étiquette un culte, tant en Nouvelle-Zélande qu'à l'étranger. Le duo Healy / Sutherland, cependant, remonte à l'époque pré-DP. Le couple s'est rencontré alors qu'ils étaient tous les deux à Cloudy Bay (Sutherland a été le viticulteur de Cloudy Bay pendant 18 ans tandis que Healy a été l'œnologue de la société pendant 12 ans. Sutherland a également été directeur de la marque avant de partir). La rencontre du duo s'avère littéralement fructueuse et en 2004 ils lancent leur propre marque, Dog Point. Avec 30 années accumulées derrière eux, ce duo puissant ne pouvait pas se tromper, et en seulement 15 petites années, Dog Point est devenu la référence pour les sauvignons blancs, les pinots noirs et les chardonnays dans le secteur.
                    </div>

                    <div class="howto-title2">Philosophies de l'ancien monde et technologie du nouveau monde</div>
                    <div class="howto-text">
                        Les vins d'Ivan et James font preuve d'une qualité et d'une complexité étonnantes. Non seulement leur argile fendue
                        terroir le meilleur de Marlborough, mais les vignes âgées de 40 ans de Dog Point sont parmi les plus anciennes du
                        région. Les rendements sont maintenus bas - au moins 50 % en dessous de la moyenne - et exceptionnellement pour la Nouvelle-Zélande, les raisins
                        sont récoltés à la main. Cela vaut la peine d'être noté car la récolte à la main est l'une des rares
                        des éléments viticoles qui n'ont pas heurté les antipodes ; 95% des vendanges se font à la machine. Leurs quatre
                        les mélanges de signature sont tous de qualité et de prix égaux, cependant, si nous devions en choisir un, ce serait
                        être le Dog Point Vineyard Section 94 Sauvignon Blanc. Le 2008 a connu une forte hausse au début du deuxième trimestre
                        2019, ce qui en fait le choix avisé des débutants du nouveau monde.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Dog Point Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One of the (many) benefits of new world wines is that they do not have the same stumbling blocks
                        that their ancestors had. Everything - from green harvests to new vs. old barrel ageing - has
                        been tried and tested. So while many of these wines are young, they have saved themselves 100
                        years so by studying best practices brought over from Europe. One such erstwhile student is Dog
                        Point Vineyards in Marlborough, New Zealand’s prime wine growing region.
                    </div>

                    <div class="howto-title2">Dog Point on point</div>
                    <div class="howto-text">
                        Almost since its inception, Dog Point has been among the very top of wine producers in New Zealand. Producing four fantastic wines, the careful craftsmanship of oenologist James Healy and viticulturist Ivan Sutherland has garnered the label a cult following, both in New Zealand and abroad. The Healy/Sutherland duo, however, dates back to pre-DP days. The pair met while they were both at Cloudy Bay, (Sutherland was Cloudy Bay&#39;s viticulturist for 18 years while Healy was the Company&#39;s Oenologist for 12 years. Sutherland was also a director of the brand prior to leaving). The meeting of the pair proved, literally, fruitful, and in 2004 they launched their own brand, Dog Point. With 30 accumulated years behind them, this powerhouse duo could do no wrong, and in just 15 short years, Dog Point has come to be considered the benchmark for Sauvignon Blancs, Pinot Noirs, and Chardonnays in the business.
                    </div>

                    <div class="howto-title2">Old world philosophies and new world technology</div>
                    <div class="howto-text">
                        Ivan and James’ wines show astounding quality and complexity. Not only is their slitty clay
                        terroir the best in Marlborough but Dog Point’s 40-year old vines are some of the oldest in the
                        region. Yields are kept low - at least 50% below average - and unusually for New Zealand, grapes
                        are hand-harvested. This is worth noting as hand harvesting is one of the few European
                        winemaking elements that has not hit the antipodes; 95% of harvests are by machine. Their four
                        signature blends are all of equal quality and price, however, if we were to choose one, it would
                        be the Dog Point Vineyard Section 94 Sauvignon Blanc. The 2008 enjoyed a sharp rise in early Q2
                        2019, making it the savvy choice of the new world newbies.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DogPointVineyards",
    data() {
        return {
            select: {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Dog Point Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the award-winning wines from Dog Point Vineyards, a premium wine producer in New Zealand known for their innovative winemaking techniques and outstanding quality.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
